<p-accordion [activeIndex]="0">
  <p-accordionTab>
    <p-header>
      <div class="history-header">TASKS</div>
    </p-header>

    <div class="tasks-list">
      <mat-tab-group [(selectedIndex)]="selectedTabIndex">
        <mat-tab *ngFor="let tab of tabs">
          <ng-template mat-tab-label>
            <span class="tab-label">{{tab.title}} ({{tab.completed}}/{{tab.total}})</span>
          </ng-template>

          <ng-container *ngIf="tab.loading">
            <lib-progress-spinner></lib-progress-spinner>
          </ng-container>

          <div class="tasks-container" *ngIf="!tab.loading">
            <div class="card-wrapper" *ngFor="let task of tab.tasks">
              <app-task-card (click)="editTask(task)" [task]="task" [fromProj]="true" [showFrom]="true"></app-task-card>
            </div>
            <div class="nfs-block no-history" *ngIf="!tab.tasks?.length">
              No {{tab.title}}
            </div>
            <div class="create-task-block">
              <button mat-button class="task-item-button" (click)="createTask()">
                <mat-icon>add</mat-icon>
                Create Task
              </button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

  </p-accordionTab>
</p-accordion>
